module.exports = function() {
  return new Worker(__webpack_public_path__ + "5ff187f92149f09934ad.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/templateWorker.js
// module id = 2071
// module chunks = 1